.hero {
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, var(--c-abyss), #071a28 54%, var(--c-deep));
  color: var(--color-text-invert);
}

.heroGlow {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    radial-gradient(circle at 78% 42%, rgb(111 211 194 / 0.16), transparent 34%),
    radial-gradient(circle at 18% 70%, rgb(70 198 221 / 0.1), transparent 40%);
}

.heroInner {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  align-items: center;
  gap: clamp(1.5rem, 4vw, 3rem);
  padding-top: clamp(4.5rem, 9vw, 7rem);
  padding-bottom: clamp(4rem, 8vw, 6rem);
  min-height: min(88dvh, 44rem);
}

.heroText {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  max-width: 34rem;
  z-index: 2;
}

.heroText :global(.eyebrow) {
  color: var(--c-aqua);
}

.heroTitle {
  max-width: 18ch;
  font-size: clamp(2.6rem, 6.2vw, 4.6rem);
  line-height: 1.05;
  color: #fff;
  text-wrap: balance;
}

.heroSubtitle {
  max-width: 38ch;
  font-size: clamp(1rem, 1.5vw, 1.15rem);
  line-height: 1.55;
  color: color-mix(in srgb, var(--color-text-invert) 80%, transparent);
}

.heroActions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  margin-top: 0.25rem;
}

.heroActions a:nth-child(2) {
  color: #e8f4f6;
  border-color: rgb(232 244 246 / 0.45);
}

.heroActions a:nth-child(2):hover {
  color: #fff;
  border-color: #fff;
  background: rgb(255 255 255 / 0.08);
}

.heroLegend {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--color-text-invert) 62%, transparent);
}

.heroScene {
  position: relative;
  height: min(52vh, 26rem);
  min-height: 18rem;
  border: 1px solid rgb(255 255 255 / 0.12);
  border-radius: var(--radius-lg);
  background: rgb(4 22 34 / 0.55);
  box-shadow: var(--shadow-atlas);
  overflow: hidden;
}

.heroFallback {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 55% 40%, rgb(111 211 194 / 0.22), transparent 40%),
    linear-gradient(160deg, #06243a, #0a3550 60%, #071a28);
}

.metricsSection {
  position: relative;
  z-index: 3;
  margin-top: -1.25rem;
  padding-bottom: clamp(3rem, 6vw, 5rem);
}

.atlasGrid {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 1.25rem;
}

.atlasGrid > :first-child {
  grid-row: span 2;
}

.contextAction {
  margin-top: 1.5rem;
}

.sdgGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8rem;
}

.ctaInner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2rem;
}

.ctaTitle {
  font-size: var(--fs-h2);
  color: var(--color-text-invert);
  max-width: 22ch;
}

.ctaBody {
  font-size: var(--fs-lead);
  color: color-mix(in srgb, var(--color-text-invert) 80%, transparent);
  max-width: 44ch;
}

@media (max-width: 940px) {
  .heroInner {
    grid-template-columns: 1fr;
    min-height: auto;
    padding-bottom: clamp(3rem, 7vw, 4.5rem);
  }

  .heroTitle {
    max-width: 16ch;
  }

  .heroScene {
    height: min(42vh, 22rem);
    order: -1;
  }

  .atlasGrid {
    grid-template-columns: 1fr;
  }

  .atlasGrid > :first-child {
    grid-row: auto;
  }

  .sdgGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .metricsSection {
    margin-top: 0;
    padding-top: 1.25rem;
  }

  .sdgGrid {
    grid-template-columns: 1fr;
  }
}
